<section>
  <h2>Event Attachments</h2>
  <div class="font-size-xs text-italic mb-3">
    Notes:
    <ol>
      <li><i>Total # of upload files allowed: {{ totalNumberOfUploadFilesAllowed }}</i></li>
      <li><i>Max size allowed per file: 5MB</i></li>
      <li><i>File types supported: PDF, JPG, PNG, TIFF, JPEG, ANB, DOC, DOCX, XLS, XLSX, PPT, PPTX, MSG</i></li>
    </ol>
  </div>
  <p-fileUpload #fileInput
                id="EventAttachments"
                name="attachments" accept=".pdf,.PDF,.jpg,.JPG,.png,.PNG,.tiff,.TIFF,.jpeg,.JPEG,.anb,.ANB,.doc,.DOC,.docx,.DOCX,.xls,.XLS,.xlsx,.XLSX,.ppt,.PPT,.pptx,.PPTX,.msg,.MSG"
                [maxFileSize]="maxFileSize"
                [multiple]="true"
                [fileLimit]="totalNumberOfUploadFilesAllowed"
                [customUpload]="true"
                [showUploadButton]="false"
                [showCancelButton]="false"
                (uploadHandler)="uploadEventAttachments($event)"
                (onError)="onUploadErrorHandler($event)"
                (onSelect)="onSelectFileHandler($event)"
                [auto]="false"
                chooseLabel="Choose"
                invalidFileSizeMessageSummary="{0}: Invalid file size."
                invalidFileSizeMessageDetail="Maximum upload size is {0}. File was NOT uploaded."
                [invalidFileLimitMessageSummary]="_maxFileLimitExceededMsg"
                invalidFileLimitMessageDetail="Limit is {0} files total."
                styleClass="mb-3">
    <ng-template pTemplate="file"> </ng-template>
  </p-fileUpload>
  <div class="cross-validation-feedback fw-bold mb-3" *ngIf="displayAttachmentErrorMessage">
    {{ attachmentUploadErrorMessage}}
  </div>
  <p-table styleClass="mb-3" [value]="attachments" dataKey="EventAttachmentID" [paginator]="true" [alwaysShowPaginator]="false" [rows]="rows" [autoLayout]="true" responsiveLayout="scroll">
    <ng-template pTemplate="caption">
      <div class="p-2 fw-bold text-center">Uploaded attachments</div>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th scope="col">File name</th>
        <th scope="col">Created by</th>
        <th scope="col">Created on</th>
        <th scope="col"><span class="visually-hidden">Remove</span></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="4">
          No uploaded attachments found.
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-file let-rowIndex="rowIndex">
      <tr>
        <th scope="row">{{file.ENESS_EventAttachments?.FileName}}</th>
        <td>{{file.ENESS_EventAttachments?.CreatedBy}}</td>
        <td>{{file.ENESS_EventAttachments?.CreatedOn | date:'MM/dd/yyyy'}}</td>
        <td class="text-center">
          <button type="button" class="btn btn-sm btn-danger" aria-label="Remove attachment" (click)="deleteUploadedAttachment(rowIndex)" title="Remove Attachment"><i class="fas fa-times" aria-hidden="true"></i><span class="visually-hidden">Remove Attachment</span></button>
        </td>
      </tr>
    </ng-template>
  </p-table>
</section>
